module.exports = __webpack_public_path__ + "img/13.7f04a9da.svg";